import React, { useMemo } from "react";
import ButtonRed from "../components/ButtonRed";
import { useNavigate } from "react-router-dom";
import MobileNavigation from "../components/MobileNavigation/MobileNavigation";
import "./MHome.scss";

function MHome() {
  const gameCards = useMemo(() => {
    const list = [];
    for (let j = 1; j <= 15; j++) {
      list.push({
        title: `Game ${j}`,
        image: `/fake-content/game-card-${j}.png`,
      });
    }
    return list;
  }, []);

  const navigate = useNavigate();

  return (
    <div className='mapp-root-content'>
      <div className='app-full-content'>
        <div
          style={{
            position: "relative",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <img
            src='/banner-mobile.png'
            alt='Banner'
            className='fake-content-main-page'
          />
          <div className='mbanner-message'>
            <h2>125% + 250 FS</h2>
            <div className='span'>Play & Win width Bonuses</div>
            <ButtonRed labelText='Join now' onClick={() => navigate("/game")} />
          </div>
        </div>
        <img
          src='/eds-mobil-home.png'
          className='fake-content-main-page'
          alt='Main content'
        />
        <img
          src='/mobile-search-grup.png'
          className='fake-content-main-page'
          alt='Main content'
        />
        <div className='fake-game-cards-wrapper'>
          {gameCards.map((card, index) => (
            <div key={index} className='fake-game-card' onClick={() => navigate("/slot")} style={{ cursor: 'pointer' }}>
              <img
                src={card.image}
                alt={card.title}
                className='fake-game-card-image'
              />
            </div>
          ))}
        </div>
      </div>
      <MobileNavigation />
    </div>
  );
}

export default MHome;
